import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isMultipleSegments, totalPax } from '../../../../redux/currentSearch/selectors';
import { FragmentHeaderMultiple } from './types/FragmentHeaderMultiple';
import { FragmentHeaderRoundTrip } from './types/FragmentHeaderRoundTrip';
import { FragmentHeaderSegment } from './types/FragmentHeaderSegment';
import { TripType } from '../../../../models';
import { SearchProp } from '../../../../models/Search';
import { SegmentContext } from '../../Segment/SegmentManager/Context';

export const PaxHeader = ({ currentSearch, activeProduct }) => {
    if (isMultipleSegments({ currentSearch })) {
        return <FragmentHeaderMultiple currentSearch={currentSearch} textKey="flightsManager.selection.pax.title" />;
    }

    const pax = totalPax({ currentSearch, activeProduct });

    if (currentSearch.tripType === TripType.ROUND_TRIP) {
        return <FragmentHeaderRoundTrip segments={currentSearch.segments} pax={pax} />;
    }

    return (
        <SegmentContext.Provider value={{ segment: currentSearch.segments[0] }}>
            <FragmentHeaderSegment pax={pax} />
        </SegmentContext.Provider>
    );
};

PaxHeader.propTypes = {
    currentSearch: SearchProp.isRequired,
    activeProduct: PropTypes.object.isRequired,
};

PaxHeader.defaultProps = {
};

const mapStateToProps = ({ currentSearch, activeProduct }) => ({
    currentSearch,
    activeProduct,
});

export const ConnectedPaxHeader = connect(mapStateToProps)(PaxHeader);
